import utils from '../utils'

const IS_PRD = utils.constants.env === 'PRD'

const credentials = {
  endpoint: 'https://api.voucherify.io',
  appId: IS_PRD ? 'd852063e-2af4-43b0-9d98-df302e2a1e2d' : '8aa9d72f-a023-4b33-b7dc-eb6d873d87b4',
  appToken: IS_PRD ? 'f23e791a-59db-4748-8284-e4098d3d225c' : '7c1300d7-0548-4567-9256-cf0974e713f3'
}

const getVoucherConfig = () => {
  return {
    url: credentials.endpoint,
    headers: {
      'X-App-Id': credentials.appId,
      'X-App-Token': credentials.appToken,
      'Content-Type': 'application/json',
    },
  }
}

export default {
  getVoucherConfig,
}



// WEBPACK FOOTER //
// ./src/config/voucherify.js